export default __webpack_public_path__ + "static/media/Img-Welcome.279b78ec.svg";